export interface Product {
  product_id: number // Added product_id
  barcode: string
  image: string
  product_name: string
  model: string // Added model property
  quantity: string // Changed to string to match new response
  item_status: string
  supplier_order_id: number // This was in the old model, but not in the new sample response. Keeping for now.
  order_id: number // This was in the old model, but not in the new sample response. Keeping for now.
  item_id: number // Added item_id
  item_type: string
  status_color: string
  item_status_id: number
  product_from: string | null // Added product_from
  actions: { // Made more generic to accept various actions from API
    [key: string]: number 
    // Examples from new response:
    // out_of_stock?: number 
    // available_later?: number
    // partially_available?: number
    // Examples from old model (if still relevant):
    // ready?: number 
  }
  removal_reason?: string // Kept as optional, was in old model
}

export const ACTION_COLORS = {
  available_later: {
    original: '#FFF176',    // Light yellow
    disabled: '#FFF9C4'     // Lighter yellow
  },
  partially_available: {
    original: '#FFB74D',    // Light orange
    disabled: '#FFE0B2'     // Lighter orange
  },
  ready: {
    original: '#81C784',    // Light green
    disabled: '#C8E6C9'     // Lighter green
  },
  out_of_stock: {
    original: '#E57373',    // Light red
    disabled: '#FFCDD2'     // Lighter red
  }
}
